/* eslint-disable no-unused-vars */
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';

const requestsToCheckRepeats = ['Date2', 'Country2'];

export const revenueReportsAPI = createApi({
  reducerPath: 'RevenueReportsAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/Revenue' }),
  tagTypes: [],
  endpoints: (build) => ({
    GetReport: build.query({
      query: (data) => {
        return {
          url: '/GetReport',
          method: 'POST',
          data,
        };
      },
      // transformResponse: (response, meta, arg) => {
      //   return response;
      // },
    }),
  }),
});
